import { render, staticRenderFns } from "./CountryDepositsBarChart.vue?vue&type=template&id=2098b350&scoped=true&"
import script from "./CountryDepositsBarChart.vue?vue&type=script&lang=js&"
export * from "./CountryDepositsBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2098b350",
  null
  
)

export default component.exports